// angular.module('records').directive('tgPhone', ['$window', function ($window) {
angular.module('utils').directive('tgPhone', [
	'$filter',
	function ($filter) {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				removeDdi: '=',
				forbidEmptyPhones: '=',
			},
			link: function (scope, element, attr, ngModel) {
				var telephoneFilter = $filter('telephone')

				function normalizeValue(value) {
					return value && value.length > 0 ? value.replace(/[^0-9]/g, '') : null
				}

				function treatPhoneNumber(value, type) {
					var normalizedValue = normalizeValue(value)
					if (!normalizedValue || normalizedValue.length == 0) {
						if (scope.forbidEmptyPhones) {
							ngModel.$setValidity('tgPhone', false)
						} else {
							ngModel.$setValidity('tgPhone', true)
						}

						return null
					}

					var formattedValue = null
					if (normalizedValue.length >= 7) {
						formattedValue = telephoneFilter(normalizedValue, false, scope.removeDdi)
					}

					if (formattedValue) {
						ngModel.$setValidity('tgPhone', true)
						if (type == 'parser') {
							ngModel.$setViewValue(formattedValue)
							ngModel.$render()
							return telephoneFilter(normalizedValue, true)
						} else {
							return formattedValue
						}
					} else {
						ngModel.$setValidity('tgPhone', false)
						if (type == 'parser') {
							ngModel.$setViewValue(normalizedValue)
							ngModel.$render()
						}
						return normalizedValue
					}
				}

				//Parsers are fired by the user input and change how view values will be set on the model
				ngModel.$parsers.push(function (value) {
					return treatPhoneNumber(value, 'parser')
				})

				//Formatters are fired when the directive model value is directly changed by code
				ngModel.$formatters.push(function (value) {
					return treatPhoneNumber(value, 'formatter')
				})
			},
		}
	},
])
